import { useEffect, useRef, useState } from 'react';
import useAudioAdapter from "@/common/hooks/useAudioAdapter.ts";
import useCurrentTrack from "@/common/hooks/useCurrentTrack.ts";
import useAudioEditorPeaksInstance from "@/common/hooks/useAudioEditorPeaksInstance.ts";

const useAudioProgress = () => {
  const [audioAdapter] = useAudioAdapter();
  const [peaksInstance] = useAudioEditorPeaksInstance()
  const [progress, setProgress] = useState(0);
  const currentTrackIdRef = useRef<string | null>(null);
  const currentTrack = useCurrentTrack();

  useEffect(() => {
    if (currentTrack && currentTrackIdRef.current !== currentTrack.id && progress > 0) {
      setProgress(0);
      currentTrackIdRef.current = currentTrack.id;
    }
  }, [
    progress,
    currentTrack
  ]);

  useEffect(() => {
    if (!peaksInstance || !audioAdapter) {
      return;
    }

    const handleTimeupdate = () => {
      setProgress(audioAdapter.getCurrentTime());
    }

    peaksInstance?.on("player.timeupdate", handleTimeupdate);

    return () => {
      peaksInstance?.off("player.timeupdate", handleTimeupdate);
    };
  }, [
    audioAdapter,
    peaksInstance
  ]);

  return {
    progress: progress || 0,
    currentTime: audioAdapter?.getCurrentTime() || 0,
    timeLeft: audioAdapter?.getTimeLeft() || 0,
  };
};

export default useAudioProgress;
